export default __webpack_public_path__ + "static/media/k3.9aa5850f.svg";